module.exports = __webpack_public_path__ + "assets/bg.d1a2889d.png";